// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1KZeC","spinner":"Loader_spinner__1Cjff"};